/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as JoinRouteImport } from './routes/join'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedArtifactsRouteImport } from './routes/_authed/artifacts'
import { Route as AuthedBrandDealsRouteImport } from './routes/_authed/brand-deals'
import { Route as AuthedCampaignsRouteImport } from './routes/_authed/campaigns'
import { Route as AuthedContentRouteImport } from './routes/_authed/content'
import { Route as AuthedDraperRouteImport } from './routes/_authed/draper'
import { Route as AuthedFindCreatorsRouteImport } from './routes/_authed/find-creators'
import { Route as AuthedInboxRouteImport } from './routes/_authed/inbox'
import { Route as AuthedInfluencersRouteImport } from './routes/_authed/influencers'
import { Route as AuthedMoneyRouteImport } from './routes/_authed/money'
import { Route as AuthedNegotiatorsRouteImport } from './routes/_authed/negotiators'
import { Route as AuthedPerformanceRouteImport } from './routes/_authed/performance'
import { Route as AuthedSearchEngineRouteImport } from './routes/_authed/search-engine'
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings'
import { Route as AuthedTasksRouteImport } from './routes/_authed/tasks'
import { Route as AuthedVisibilityRouteImport } from './routes/_authed/visibility'
import { Route as AuthSigninRouteImport } from './routes/auth/signin'
import { Route as CreatorTokenRouteImport } from './routes/creator.$token'
import { Route as SignTokenRouteImport } from './routes/sign.$token'
import { Route as SlackLinkRouteImport } from './routes/slack/link'
import { Route as UploadTokenRouteImport } from './routes/upload.$token'
import { Route as AuthedAdminAhsRouteImport } from './routes/_authed/admin/ahs'
import { Route as AuthedAdminDraftEvalsRouteImport } from './routes/_authed/admin/draft-evals'
import { Route as AuthedAdminDraftPreviewRouteImport } from './routes/_authed/admin/draft-preview'
import { Route as AuthedAdminDraperRouteImport } from './routes/_authed/admin/draper'
import { Route as AuthedAdminInsightsRouteImport } from './routes/_authed/admin/insights'
import { Route as AuthedOperationsIndexRouteImport } from './routes/_authed/operations/index'
import { Route as AuthedOperationsDealsRouteImport } from './routes/_authed/operations/deals'
import { Route as AuthedPastVideosIndexRouteImport } from './routes/_authed/past-videos/index'
import { Route as AuthedPastVideosSetIdRouteImport } from './routes/_authed/past-videos/$setId'
import { Route as AuthedReviewIndexRouteImport } from './routes/_authed/review/index'
import { Route as AuthedReviewKindRouteImport } from './routes/_authed/review/$kind'
import { Route as CreatorTokenIndexRouteImport } from './routes/creator.$token.index'
import { Route as AuthedAdminClientViewPreviewIdRouteImport } from './routes/_authed/admin/client-view.$previewId'
import { Route as AuthedReviewPastVideosIndexRouteImport } from './routes/_authed/review/past-videos/index'
import { Route as AuthedReviewPastVideosSetIdRouteImport } from './routes/_authed/review/past-videos/$setId'
import { Route as CreatorTokenBriefsDealIdRouteImport } from './routes/creator.$token.briefs.$dealId'
import { Route as CreatorTokenContractsContractUuidRouteImport } from './routes/creator.$token.contracts.$contractUuid'
import { Route as CreatorTokenVideosVideoIdRouteImport } from './routes/creator.$token.videos.$videoId'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedArtifactsRoute = AuthedArtifactsRouteImport.update({
  id: '/artifacts',
  path: '/artifacts',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBrandDealsRoute = AuthedBrandDealsRouteImport.update({
  id: '/brand-deals',
  path: '/brand-deals',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCampaignsRoute = AuthedCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedContentRoute = AuthedContentRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDraperRoute = AuthedDraperRouteImport.update({
  id: '/draper',
  path: '/draper',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFindCreatorsRoute = AuthedFindCreatorsRouteImport.update({
  id: '/find-creators',
  path: '/find-creators',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInboxRoute = AuthedInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInfluencersRoute = AuthedInfluencersRouteImport.update({
  id: '/influencers',
  path: '/influencers',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMoneyRoute = AuthedMoneyRouteImport.update({
  id: '/money',
  path: '/money',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedNegotiatorsRoute = AuthedNegotiatorsRouteImport.update({
  id: '/negotiators',
  path: '/negotiators',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPerformanceRoute = AuthedPerformanceRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSearchEngineRoute = AuthedSearchEngineRouteImport.update({
  id: '/search-engine',
  path: '/search-engine',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTasksRoute = AuthedTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedVisibilityRoute = AuthedVisibilityRouteImport.update({
  id: '/visibility',
  path: '/visibility',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/auth/signin',
  path: '/auth/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const CreatorTokenRoute = CreatorTokenRouteImport.update({
  id: '/creator/$token',
  path: '/creator/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SignTokenRoute = SignTokenRouteImport.update({
  id: '/sign/$token',
  path: '/sign/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SlackLinkRoute = SlackLinkRouteImport.update({
  id: '/slack/link',
  path: '/slack/link',
  getParentRoute: () => rootRouteImport,
} as any)
const UploadTokenRoute = UploadTokenRouteImport.update({
  id: '/upload/$token',
  path: '/upload/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedAdminAhsRoute = AuthedAdminAhsRouteImport.update({
  id: '/admin/ahs',
  path: '/admin/ahs',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminDraftEvalsRoute = AuthedAdminDraftEvalsRouteImport.update({
  id: '/admin/draft-evals',
  path: '/admin/draft-evals',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminDraftPreviewRoute = AuthedAdminDraftPreviewRouteImport.update({
  id: '/admin/draft-preview',
  path: '/admin/draft-preview',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminDraperRoute = AuthedAdminDraperRouteImport.update({
  id: '/admin/draper',
  path: '/admin/draper',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminInsightsRoute = AuthedAdminInsightsRouteImport.update({
  id: '/admin/insights',
  path: '/admin/insights',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOperationsIndexRoute = AuthedOperationsIndexRouteImport.update({
  id: '/operations/',
  path: '/operations/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOperationsDealsRoute = AuthedOperationsDealsRouteImport.update({
  id: '/operations/deals',
  path: '/operations/deals',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPastVideosIndexRoute = AuthedPastVideosIndexRouteImport.update({
  id: '/past-videos/',
  path: '/past-videos/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPastVideosSetIdRoute = AuthedPastVideosSetIdRouteImport.update({
  id: '/past-videos/$setId',
  path: '/past-videos/$setId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReviewIndexRoute = AuthedReviewIndexRouteImport.update({
  id: '/review/',
  path: '/review/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReviewKindRoute = AuthedReviewKindRouteImport.update({
  id: '/review/$kind',
  path: '/review/$kind',
  getParentRoute: () => AuthedRoute,
} as any)
const CreatorTokenIndexRoute = CreatorTokenIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CreatorTokenRoute,
} as any)
const AuthedAdminClientViewPreviewIdRoute =
  AuthedAdminClientViewPreviewIdRouteImport.update({
    id: '/admin/client-view/$previewId',
    path: '/admin/client-view/$previewId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedReviewPastVideosIndexRoute =
  AuthedReviewPastVideosIndexRouteImport.update({
    id: '/review/past-videos/',
    path: '/review/past-videos/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedReviewPastVideosSetIdRoute =
  AuthedReviewPastVideosSetIdRouteImport.update({
    id: '/review/past-videos/$setId',
    path: '/review/past-videos/$setId',
    getParentRoute: () => AuthedRoute,
  } as any)
const CreatorTokenBriefsDealIdRoute =
  CreatorTokenBriefsDealIdRouteImport.update({
    id: '/briefs/$dealId',
    path: '/briefs/$dealId',
    getParentRoute: () => CreatorTokenRoute,
  } as any)
const CreatorTokenContractsContractUuidRoute =
  CreatorTokenContractsContractUuidRouteImport.update({
    id: '/contracts/$contractUuid',
    path: '/contracts/$contractUuid',
    getParentRoute: () => CreatorTokenRoute,
  } as any)
const CreatorTokenVideosVideoIdRoute =
  CreatorTokenVideosVideoIdRouteImport.update({
    id: '/videos/$videoId',
    path: '/videos/$videoId',
    getParentRoute: () => CreatorTokenRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/join': typeof JoinRoute
  '/artifacts': typeof AuthedArtifactsRoute
  '/brand-deals': typeof AuthedBrandDealsRoute
  '/campaigns': typeof AuthedCampaignsRoute
  '/content': typeof AuthedContentRoute
  '/draper': typeof AuthedDraperRoute
  '/find-creators': typeof AuthedFindCreatorsRoute
  '/inbox': typeof AuthedInboxRoute
  '/influencers': typeof AuthedInfluencersRoute
  '/money': typeof AuthedMoneyRoute
  '/negotiators': typeof AuthedNegotiatorsRoute
  '/performance': typeof AuthedPerformanceRoute
  '/search-engine': typeof AuthedSearchEngineRoute
  '/settings': typeof AuthedSettingsRoute
  '/tasks': typeof AuthedTasksRoute
  '/visibility': typeof AuthedVisibilityRoute
  '/auth/signin': typeof AuthSigninRoute
  '/creator/$token': typeof CreatorTokenRouteWithChildren
  '/sign/$token': typeof SignTokenRoute
  '/slack/link': typeof SlackLinkRoute
  '/upload/$token': typeof UploadTokenRoute
  '/admin/ahs': typeof AuthedAdminAhsRoute
  '/admin/draft-evals': typeof AuthedAdminDraftEvalsRoute
  '/admin/draft-preview': typeof AuthedAdminDraftPreviewRoute
  '/admin/draper': typeof AuthedAdminDraperRoute
  '/admin/insights': typeof AuthedAdminInsightsRoute
  '/operations/deals': typeof AuthedOperationsDealsRoute
  '/past-videos/$setId': typeof AuthedPastVideosSetIdRoute
  '/review/$kind': typeof AuthedReviewKindRoute
  '/operations/': typeof AuthedOperationsIndexRoute
  '/past-videos/': typeof AuthedPastVideosIndexRoute
  '/review/': typeof AuthedReviewIndexRoute
  '/creator/$token/': typeof CreatorTokenIndexRoute
  '/admin/client-view/$previewId': typeof AuthedAdminClientViewPreviewIdRoute
  '/review/past-videos/$setId': typeof AuthedReviewPastVideosSetIdRoute
  '/creator/$token/briefs/$dealId': typeof CreatorTokenBriefsDealIdRoute
  '/creator/$token/contracts/$contractUuid': typeof CreatorTokenContractsContractUuidRoute
  '/creator/$token/videos/$videoId': typeof CreatorTokenVideosVideoIdRoute
  '/review/past-videos/': typeof AuthedReviewPastVideosIndexRoute
}
export interface FileRoutesByTo {
  '/join': typeof JoinRoute
  '/artifacts': typeof AuthedArtifactsRoute
  '/brand-deals': typeof AuthedBrandDealsRoute
  '/campaigns': typeof AuthedCampaignsRoute
  '/content': typeof AuthedContentRoute
  '/draper': typeof AuthedDraperRoute
  '/find-creators': typeof AuthedFindCreatorsRoute
  '/inbox': typeof AuthedInboxRoute
  '/influencers': typeof AuthedInfluencersRoute
  '/money': typeof AuthedMoneyRoute
  '/negotiators': typeof AuthedNegotiatorsRoute
  '/performance': typeof AuthedPerformanceRoute
  '/search-engine': typeof AuthedSearchEngineRoute
  '/settings': typeof AuthedSettingsRoute
  '/tasks': typeof AuthedTasksRoute
  '/visibility': typeof AuthedVisibilityRoute
  '/auth/signin': typeof AuthSigninRoute
  '/sign/$token': typeof SignTokenRoute
  '/slack/link': typeof SlackLinkRoute
  '/upload/$token': typeof UploadTokenRoute
  '/': typeof AuthedIndexRoute
  '/admin/ahs': typeof AuthedAdminAhsRoute
  '/admin/draft-evals': typeof AuthedAdminDraftEvalsRoute
  '/admin/draft-preview': typeof AuthedAdminDraftPreviewRoute
  '/admin/draper': typeof AuthedAdminDraperRoute
  '/admin/insights': typeof AuthedAdminInsightsRoute
  '/operations/deals': typeof AuthedOperationsDealsRoute
  '/past-videos/$setId': typeof AuthedPastVideosSetIdRoute
  '/review/$kind': typeof AuthedReviewKindRoute
  '/operations': typeof AuthedOperationsIndexRoute
  '/past-videos': typeof AuthedPastVideosIndexRoute
  '/review': typeof AuthedReviewIndexRoute
  '/creator/$token': typeof CreatorTokenIndexRoute
  '/admin/client-view/$previewId': typeof AuthedAdminClientViewPreviewIdRoute
  '/review/past-videos/$setId': typeof AuthedReviewPastVideosSetIdRoute
  '/creator/$token/briefs/$dealId': typeof CreatorTokenBriefsDealIdRoute
  '/creator/$token/contracts/$contractUuid': typeof CreatorTokenContractsContractUuidRoute
  '/creator/$token/videos/$videoId': typeof CreatorTokenVideosVideoIdRoute
  '/review/past-videos': typeof AuthedReviewPastVideosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/join': typeof JoinRoute
  '/_authed/artifacts': typeof AuthedArtifactsRoute
  '/_authed/brand-deals': typeof AuthedBrandDealsRoute
  '/_authed/campaigns': typeof AuthedCampaignsRoute
  '/_authed/content': typeof AuthedContentRoute
  '/_authed/draper': typeof AuthedDraperRoute
  '/_authed/find-creators': typeof AuthedFindCreatorsRoute
  '/_authed/inbox': typeof AuthedInboxRoute
  '/_authed/influencers': typeof AuthedInfluencersRoute
  '/_authed/money': typeof AuthedMoneyRoute
  '/_authed/negotiators': typeof AuthedNegotiatorsRoute
  '/_authed/performance': typeof AuthedPerformanceRoute
  '/_authed/search-engine': typeof AuthedSearchEngineRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/tasks': typeof AuthedTasksRoute
  '/_authed/visibility': typeof AuthedVisibilityRoute
  '/auth/signin': typeof AuthSigninRoute
  '/creator/$token': typeof CreatorTokenRouteWithChildren
  '/sign/$token': typeof SignTokenRoute
  '/slack/link': typeof SlackLinkRoute
  '/upload/$token': typeof UploadTokenRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/admin/ahs': typeof AuthedAdminAhsRoute
  '/_authed/admin/draft-evals': typeof AuthedAdminDraftEvalsRoute
  '/_authed/admin/draft-preview': typeof AuthedAdminDraftPreviewRoute
  '/_authed/admin/draper': typeof AuthedAdminDraperRoute
  '/_authed/admin/insights': typeof AuthedAdminInsightsRoute
  '/_authed/operations/deals': typeof AuthedOperationsDealsRoute
  '/_authed/past-videos/$setId': typeof AuthedPastVideosSetIdRoute
  '/_authed/review/$kind': typeof AuthedReviewKindRoute
  '/_authed/operations/': typeof AuthedOperationsIndexRoute
  '/_authed/past-videos/': typeof AuthedPastVideosIndexRoute
  '/_authed/review/': typeof AuthedReviewIndexRoute
  '/creator/$token/': typeof CreatorTokenIndexRoute
  '/_authed/admin/client-view/$previewId': typeof AuthedAdminClientViewPreviewIdRoute
  '/_authed/review/past-videos/$setId': typeof AuthedReviewPastVideosSetIdRoute
  '/creator/$token/briefs/$dealId': typeof CreatorTokenBriefsDealIdRoute
  '/creator/$token/contracts/$contractUuid': typeof CreatorTokenContractsContractUuidRoute
  '/creator/$token/videos/$videoId': typeof CreatorTokenVideosVideoIdRoute
  '/_authed/review/past-videos/': typeof AuthedReviewPastVideosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/join'
    | '/artifacts'
    | '/brand-deals'
    | '/campaigns'
    | '/content'
    | '/draper'
    | '/find-creators'
    | '/inbox'
    | '/influencers'
    | '/money'
    | '/negotiators'
    | '/performance'
    | '/search-engine'
    | '/settings'
    | '/tasks'
    | '/visibility'
    | '/auth/signin'
    | '/creator/$token'
    | '/sign/$token'
    | '/slack/link'
    | '/upload/$token'
    | '/admin/ahs'
    | '/admin/draft-evals'
    | '/admin/draft-preview'
    | '/admin/draper'
    | '/admin/insights'
    | '/operations/deals'
    | '/past-videos/$setId'
    | '/review/$kind'
    | '/operations/'
    | '/past-videos/'
    | '/review/'
    | '/creator/$token/'
    | '/admin/client-view/$previewId'
    | '/review/past-videos/$setId'
    | '/creator/$token/briefs/$dealId'
    | '/creator/$token/contracts/$contractUuid'
    | '/creator/$token/videos/$videoId'
    | '/review/past-videos/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/join'
    | '/artifacts'
    | '/brand-deals'
    | '/campaigns'
    | '/content'
    | '/draper'
    | '/find-creators'
    | '/inbox'
    | '/influencers'
    | '/money'
    | '/negotiators'
    | '/performance'
    | '/search-engine'
    | '/settings'
    | '/tasks'
    | '/visibility'
    | '/auth/signin'
    | '/sign/$token'
    | '/slack/link'
    | '/upload/$token'
    | '/'
    | '/admin/ahs'
    | '/admin/draft-evals'
    | '/admin/draft-preview'
    | '/admin/draper'
    | '/admin/insights'
    | '/operations/deals'
    | '/past-videos/$setId'
    | '/review/$kind'
    | '/operations'
    | '/past-videos'
    | '/review'
    | '/creator/$token'
    | '/admin/client-view/$previewId'
    | '/review/past-videos/$setId'
    | '/creator/$token/briefs/$dealId'
    | '/creator/$token/contracts/$contractUuid'
    | '/creator/$token/videos/$videoId'
    | '/review/past-videos'
  id:
    | '__root__'
    | '/_authed'
    | '/join'
    | '/_authed/artifacts'
    | '/_authed/brand-deals'
    | '/_authed/campaigns'
    | '/_authed/content'
    | '/_authed/draper'
    | '/_authed/find-creators'
    | '/_authed/inbox'
    | '/_authed/influencers'
    | '/_authed/money'
    | '/_authed/negotiators'
    | '/_authed/performance'
    | '/_authed/search-engine'
    | '/_authed/settings'
    | '/_authed/tasks'
    | '/_authed/visibility'
    | '/auth/signin'
    | '/creator/$token'
    | '/sign/$token'
    | '/slack/link'
    | '/upload/$token'
    | '/_authed/'
    | '/_authed/admin/ahs'
    | '/_authed/admin/draft-evals'
    | '/_authed/admin/draft-preview'
    | '/_authed/admin/draper'
    | '/_authed/admin/insights'
    | '/_authed/operations/deals'
    | '/_authed/past-videos/$setId'
    | '/_authed/review/$kind'
    | '/_authed/operations/'
    | '/_authed/past-videos/'
    | '/_authed/review/'
    | '/creator/$token/'
    | '/_authed/admin/client-view/$previewId'
    | '/_authed/review/past-videos/$setId'
    | '/creator/$token/briefs/$dealId'
    | '/creator/$token/contracts/$contractUuid'
    | '/creator/$token/videos/$videoId'
    | '/_authed/review/past-videos/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  JoinRoute: typeof JoinRoute
  AuthSigninRoute: typeof AuthSigninRoute
  CreatorTokenRoute: typeof CreatorTokenRouteWithChildren
  SignTokenRoute: typeof SignTokenRoute
  SlackLinkRoute: typeof SlackLinkRoute
  UploadTokenRoute: typeof UploadTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/artifacts': {
      id: '/_authed/artifacts'
      path: '/artifacts'
      fullPath: '/artifacts'
      preLoaderRoute: typeof AuthedArtifactsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/brand-deals': {
      id: '/_authed/brand-deals'
      path: '/brand-deals'
      fullPath: '/brand-deals'
      preLoaderRoute: typeof AuthedBrandDealsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/campaigns': {
      id: '/_authed/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof AuthedCampaignsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/content': {
      id: '/_authed/content'
      path: '/content'
      fullPath: '/content'
      preLoaderRoute: typeof AuthedContentRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/draper': {
      id: '/_authed/draper'
      path: '/draper'
      fullPath: '/draper'
      preLoaderRoute: typeof AuthedDraperRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/find-creators': {
      id: '/_authed/find-creators'
      path: '/find-creators'
      fullPath: '/find-creators'
      preLoaderRoute: typeof AuthedFindCreatorsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/inbox': {
      id: '/_authed/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthedInboxRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/influencers': {
      id: '/_authed/influencers'
      path: '/influencers'
      fullPath: '/influencers'
      preLoaderRoute: typeof AuthedInfluencersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/money': {
      id: '/_authed/money'
      path: '/money'
      fullPath: '/money'
      preLoaderRoute: typeof AuthedMoneyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/negotiators': {
      id: '/_authed/negotiators'
      path: '/negotiators'
      fullPath: '/negotiators'
      preLoaderRoute: typeof AuthedNegotiatorsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/performance': {
      id: '/_authed/performance'
      path: '/performance'
      fullPath: '/performance'
      preLoaderRoute: typeof AuthedPerformanceRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/search-engine': {
      id: '/_authed/search-engine'
      path: '/search-engine'
      fullPath: '/search-engine'
      preLoaderRoute: typeof AuthedSearchEngineRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/tasks': {
      id: '/_authed/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthedTasksRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/visibility': {
      id: '/_authed/visibility'
      path: '/visibility'
      fullPath: '/visibility'
      preLoaderRoute: typeof AuthedVisibilityRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/auth/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creator/$token': {
      id: '/creator/$token'
      path: '/creator/$token'
      fullPath: '/creator/$token'
      preLoaderRoute: typeof CreatorTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign/$token': {
      id: '/sign/$token'
      path: '/sign/$token'
      fullPath: '/sign/$token'
      preLoaderRoute: typeof SignTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/slack/link': {
      id: '/slack/link'
      path: '/slack/link'
      fullPath: '/slack/link'
      preLoaderRoute: typeof SlackLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upload/$token': {
      id: '/upload/$token'
      path: '/upload/$token'
      fullPath: '/upload/$token'
      preLoaderRoute: typeof UploadTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/admin/ahs': {
      id: '/_authed/admin/ahs'
      path: '/admin/ahs'
      fullPath: '/admin/ahs'
      preLoaderRoute: typeof AuthedAdminAhsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/draft-evals': {
      id: '/_authed/admin/draft-evals'
      path: '/admin/draft-evals'
      fullPath: '/admin/draft-evals'
      preLoaderRoute: typeof AuthedAdminDraftEvalsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/draft-preview': {
      id: '/_authed/admin/draft-preview'
      path: '/admin/draft-preview'
      fullPath: '/admin/draft-preview'
      preLoaderRoute: typeof AuthedAdminDraftPreviewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/draper': {
      id: '/_authed/admin/draper'
      path: '/admin/draper'
      fullPath: '/admin/draper'
      preLoaderRoute: typeof AuthedAdminDraperRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/insights': {
      id: '/_authed/admin/insights'
      path: '/admin/insights'
      fullPath: '/admin/insights'
      preLoaderRoute: typeof AuthedAdminInsightsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/operations/': {
      id: '/_authed/operations/'
      path: '/operations'
      fullPath: '/operations/'
      preLoaderRoute: typeof AuthedOperationsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/operations/deals': {
      id: '/_authed/operations/deals'
      path: '/operations/deals'
      fullPath: '/operations/deals'
      preLoaderRoute: typeof AuthedOperationsDealsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/past-videos/': {
      id: '/_authed/past-videos/'
      path: '/past-videos'
      fullPath: '/past-videos/'
      preLoaderRoute: typeof AuthedPastVideosIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/past-videos/$setId': {
      id: '/_authed/past-videos/$setId'
      path: '/past-videos/$setId'
      fullPath: '/past-videos/$setId'
      preLoaderRoute: typeof AuthedPastVideosSetIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/review/': {
      id: '/_authed/review/'
      path: '/review'
      fullPath: '/review/'
      preLoaderRoute: typeof AuthedReviewIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/review/$kind': {
      id: '/_authed/review/$kind'
      path: '/review/$kind'
      fullPath: '/review/$kind'
      preLoaderRoute: typeof AuthedReviewKindRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/creator/$token/': {
      id: '/creator/$token/'
      path: '/'
      fullPath: '/creator/$token/'
      preLoaderRoute: typeof CreatorTokenIndexRouteImport
      parentRoute: typeof CreatorTokenRoute
    }
    '/_authed/admin/client-view/$previewId': {
      id: '/_authed/admin/client-view/$previewId'
      path: '/admin/client-view/$previewId'
      fullPath: '/admin/client-view/$previewId'
      preLoaderRoute: typeof AuthedAdminClientViewPreviewIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/review/past-videos/': {
      id: '/_authed/review/past-videos/'
      path: '/review/past-videos'
      fullPath: '/review/past-videos/'
      preLoaderRoute: typeof AuthedReviewPastVideosIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/review/past-videos/$setId': {
      id: '/_authed/review/past-videos/$setId'
      path: '/review/past-videos/$setId'
      fullPath: '/review/past-videos/$setId'
      preLoaderRoute: typeof AuthedReviewPastVideosSetIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/creator/$token/briefs/$dealId': {
      id: '/creator/$token/briefs/$dealId'
      path: '/briefs/$dealId'
      fullPath: '/creator/$token/briefs/$dealId'
      preLoaderRoute: typeof CreatorTokenBriefsDealIdRouteImport
      parentRoute: typeof CreatorTokenRoute
    }
    '/creator/$token/contracts/$contractUuid': {
      id: '/creator/$token/contracts/$contractUuid'
      path: '/contracts/$contractUuid'
      fullPath: '/creator/$token/contracts/$contractUuid'
      preLoaderRoute: typeof CreatorTokenContractsContractUuidRouteImport
      parentRoute: typeof CreatorTokenRoute
    }
    '/creator/$token/videos/$videoId': {
      id: '/creator/$token/videos/$videoId'
      path: '/videos/$videoId'
      fullPath: '/creator/$token/videos/$videoId'
      preLoaderRoute: typeof CreatorTokenVideosVideoIdRouteImport
      parentRoute: typeof CreatorTokenRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedArtifactsRoute: typeof AuthedArtifactsRoute
  AuthedBrandDealsRoute: typeof AuthedBrandDealsRoute
  AuthedCampaignsRoute: typeof AuthedCampaignsRoute
  AuthedContentRoute: typeof AuthedContentRoute
  AuthedDraperRoute: typeof AuthedDraperRoute
  AuthedFindCreatorsRoute: typeof AuthedFindCreatorsRoute
  AuthedInboxRoute: typeof AuthedInboxRoute
  AuthedInfluencersRoute: typeof AuthedInfluencersRoute
  AuthedMoneyRoute: typeof AuthedMoneyRoute
  AuthedNegotiatorsRoute: typeof AuthedNegotiatorsRoute
  AuthedPerformanceRoute: typeof AuthedPerformanceRoute
  AuthedSearchEngineRoute: typeof AuthedSearchEngineRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedTasksRoute: typeof AuthedTasksRoute
  AuthedVisibilityRoute: typeof AuthedVisibilityRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedAdminAhsRoute: typeof AuthedAdminAhsRoute
  AuthedAdminDraftEvalsRoute: typeof AuthedAdminDraftEvalsRoute
  AuthedAdminDraftPreviewRoute: typeof AuthedAdminDraftPreviewRoute
  AuthedAdminDraperRoute: typeof AuthedAdminDraperRoute
  AuthedAdminInsightsRoute: typeof AuthedAdminInsightsRoute
  AuthedOperationsDealsRoute: typeof AuthedOperationsDealsRoute
  AuthedPastVideosSetIdRoute: typeof AuthedPastVideosSetIdRoute
  AuthedReviewKindRoute: typeof AuthedReviewKindRoute
  AuthedOperationsIndexRoute: typeof AuthedOperationsIndexRoute
  AuthedPastVideosIndexRoute: typeof AuthedPastVideosIndexRoute
  AuthedReviewIndexRoute: typeof AuthedReviewIndexRoute
  AuthedAdminClientViewPreviewIdRoute: typeof AuthedAdminClientViewPreviewIdRoute
  AuthedReviewPastVideosSetIdRoute: typeof AuthedReviewPastVideosSetIdRoute
  AuthedReviewPastVideosIndexRoute: typeof AuthedReviewPastVideosIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedArtifactsRoute: AuthedArtifactsRoute,
  AuthedBrandDealsRoute: AuthedBrandDealsRoute,
  AuthedCampaignsRoute: AuthedCampaignsRoute,
  AuthedContentRoute: AuthedContentRoute,
  AuthedDraperRoute: AuthedDraperRoute,
  AuthedFindCreatorsRoute: AuthedFindCreatorsRoute,
  AuthedInboxRoute: AuthedInboxRoute,
  AuthedInfluencersRoute: AuthedInfluencersRoute,
  AuthedMoneyRoute: AuthedMoneyRoute,
  AuthedNegotiatorsRoute: AuthedNegotiatorsRoute,
  AuthedPerformanceRoute: AuthedPerformanceRoute,
  AuthedSearchEngineRoute: AuthedSearchEngineRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedTasksRoute: AuthedTasksRoute,
  AuthedVisibilityRoute: AuthedVisibilityRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedAdminAhsRoute: AuthedAdminAhsRoute,
  AuthedAdminDraftEvalsRoute: AuthedAdminDraftEvalsRoute,
  AuthedAdminDraftPreviewRoute: AuthedAdminDraftPreviewRoute,
  AuthedAdminDraperRoute: AuthedAdminDraperRoute,
  AuthedAdminInsightsRoute: AuthedAdminInsightsRoute,
  AuthedOperationsDealsRoute: AuthedOperationsDealsRoute,
  AuthedPastVideosSetIdRoute: AuthedPastVideosSetIdRoute,
  AuthedReviewKindRoute: AuthedReviewKindRoute,
  AuthedOperationsIndexRoute: AuthedOperationsIndexRoute,
  AuthedPastVideosIndexRoute: AuthedPastVideosIndexRoute,
  AuthedReviewIndexRoute: AuthedReviewIndexRoute,
  AuthedAdminClientViewPreviewIdRoute: AuthedAdminClientViewPreviewIdRoute,
  AuthedReviewPastVideosSetIdRoute: AuthedReviewPastVideosSetIdRoute,
  AuthedReviewPastVideosIndexRoute: AuthedReviewPastVideosIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface CreatorTokenRouteChildren {
  CreatorTokenIndexRoute: typeof CreatorTokenIndexRoute
  CreatorTokenBriefsDealIdRoute: typeof CreatorTokenBriefsDealIdRoute
  CreatorTokenContractsContractUuidRoute: typeof CreatorTokenContractsContractUuidRoute
  CreatorTokenVideosVideoIdRoute: typeof CreatorTokenVideosVideoIdRoute
}

const CreatorTokenRouteChildren: CreatorTokenRouteChildren = {
  CreatorTokenIndexRoute: CreatorTokenIndexRoute,
  CreatorTokenBriefsDealIdRoute: CreatorTokenBriefsDealIdRoute,
  CreatorTokenContractsContractUuidRoute:
    CreatorTokenContractsContractUuidRoute,
  CreatorTokenVideosVideoIdRoute: CreatorTokenVideosVideoIdRoute,
}

const CreatorTokenRouteWithChildren = CreatorTokenRoute._addFileChildren(
  CreatorTokenRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  JoinRoute: JoinRoute,
  AuthSigninRoute: AuthSigninRoute,
  CreatorTokenRoute: CreatorTokenRouteWithChildren,
  SignTokenRoute: SignTokenRoute,
  SlackLinkRoute: SlackLinkRoute,
  UploadTokenRoute: UploadTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
